import { render, staticRenderFns } from "./Admin2.vue?vue&type=template&id=1525facd&scoped=true&"
import script from "./Admin2.vue?vue&type=script&lang=js&"
export * from "./Admin2.vue?vue&type=script&lang=js&"
import style0 from "./Admin2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Admin2.vue?vue&type=style&index=1&id=1525facd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1525facd",
  null
  
)

export default component.exports